export default el => {
	const steps = el.querySelectorAll('.js-step');
	var current = 0;

	const goToStep = (i) => {

		if (i < 0 || i > steps.length - 1) { return }

		current = i;

		steps.forEach((step, j) => {
			step.classList[i == j ? 'add' : 'remove']('active');
			const inner = step.querySelector('.js-step-inner');
			inner.scrollTo(0, 0);
		})

		el.parentNode.scrollTo(0, 0);

		const event =  new CustomEvent("stepper", {
		 	detail: {
		    	step: current,
		  	},
		});
		document.dispatchEvent(event);
	}

	steps.forEach(step => {
		const prev = step.querySelectorAll('.js-step-prev');
		const next = step.querySelectorAll('.js-step-next');

		if (prev) {
			prev.forEach(item => {
				item.addEventListener('click', () => { goToStep(current - 1) });
			})
		}

		if (next) {
			next.forEach(item => {
				item.addEventListener('click', () => { goToStep(current + 1) });
			})
		}
	})

	window.stepper_goToStep = goToStep;
};